// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"72e7b0fa","879":"91cb845c"}[chunkId] + ".chunk.js";
};